// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__GILzS","containerItemsCenter":"Skeleton_containerItemsCenter__2EeKO"};